// extracted by mini-css-extract-plugin
export default {"container":"uploadDashboard_container__+j4yl"};